import React from "react";
import { Route, withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getState } from "../../store/configure/configureStore";
import auth from "./auth";
import MainLayout from "../MainLayout/MainLayout";

const RestrictedRoute = ({ component: Component, permissions, ...rest }) => {
  const loggedInUserRole = getState().auth?.userRole; // Get role from Redux

  // Helper function to check user access
  const hasAccess = () => permissions?.includes(loggedInUserRole);

  return (
    // <Route
    //   {...rest}
    //   render={(props) => {
    //     return (
    //       <div>
    //         <TopNavBar />

    //         <Component {...props} />
    //       </div>
    //     );
    //   }}
    // />

    <Route
      {...rest}
      render={(props) => {
        if (auth.isAuthenticated()) {
          return hasAccess() ? (
            <MainLayout>
              <Component {...props} />
            </MainLayout>
          ) : (
            <Redirect to="/login" /> //if authenticated the login page will redirect based on role
          );
        } else {
          return <Redirect to="/login" />;
        }
      }}
    />
  );
};

const mapStateToProps = (state) => ({});

export default withRouter(connect(mapStateToProps)(RestrictedRoute));
